import { Route } from "@angular/router";
import { OrderDetailsComponent } from "./order-details.component";
import { OrderDetailsResolver } from "../shared/order-details.resolver";

export const OrderDetailsRouting: Route = {
  path: ':order/:isRecla',
  component: OrderDetailsComponent,
  resolve:{
    order: OrderDetailsResolver
  },
  outlet: 'sidebar',
  data: {
    breadcrumb: "Details"
  }
};
